import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Driver } from 'app/models/driver.model';
import { DriverService } from 'app/services/driver/driver.service';
import { UserService } from 'app/services/users/user.service';
import { EditDriverComponent } from './edit-driver/edit-driver.component';

@Component({
  selector: 'app-drivers',
  templateUrl: './drivers.component.html',
  styleUrls: ['./drivers.component.css']
})
export class DriversComponent implements OnInit {

  title: string = 'Conductores'
  drivers: Driver[];
  driver: Driver;
  displayedColumns = ['name', 'phone', 'identification', 'actions'];
  driversDataSource: MatTableDataSource<Driver>;
  @ViewChild(MatPaginator) driversPaginator: MatPaginator;
  constructor(private driverService: DriverService, private dialog: MatDialog, private userService: UserService) { }

  async ngOnInit() {
    this.driver = new Driver();
    // await this.driverService.getDrivers();
  }

  async ngAfterViewInit(){
    console.log('after view')
    await this.getDrivers();
  }


  openEdit(){
    const dialogRef = this.dialog.open(EditDriverComponent, {
      data: {
        documentNumber: this.driver.documentNumber,
        name: this.driver.name,
        lastName: this.driver.lastName,
        phone: this.driver.phone,
        mobile: this.driver.mobile,
        address: this.driver.address,
        birthDate: this.driver.birthDate,
        id: this.driver.id,
        uid: this.driver.user_uid
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('dialogo cerrado!');
      this.ngOnInit();
    })
  }

  async getDrivers(){
    this.drivers = await this.driverService.getDrivers();
    this.driversDataSource = new MatTableDataSource<Driver>(this.drivers);
    this.driversDataSource.paginator = this.driversPaginator;
  }

  updateDriver(driver: Driver){
    this.driver = driver;
    this.driver.id = driver.id;
    this.openEdit();
  }

}
